import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { Reveal, Eyebrow, MaskLines } from "@/components/Motion";

export const SectionHead = ({ eyebrow, title, intro, testId, aside }) => (
  <div className="mb-14 grid gap-8 border-b border-[#8EA3BC]/40 pb-10 lg:grid-cols-12 lg:items-end" data-testid={testId}>
    <div className="lg:col-span-8">
      <Eyebrow>{eyebrow}</Eyebrow>
      <h2 className="mt-5 font-serif text-3xl leading-[1.1] text-[#1E3A5F] sm:text-4xl lg:text-5xl"><MaskLines lines={[title]} onView /></h2>
    </div>
    {(intro || aside) && (
      <Reveal className="lg:col-span-4">
        {intro && <p className="text-base leading-relaxed text-[#4A5D75] md:text-lg">{intro}</p>}
        {aside}
      </Reveal>
    )}
  </div>
);

export const QuoteBand = ({ title, testId = "quote-band" }) => {
  const { t, lp } = useLang();
  return (
    <section className="border-t border-[#8EA3BC]/40 bg-[#F7F9FB] py-20" data-testid={testId}>
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 sm:px-8 md:flex-row md:items-center md:justify-between lg:px-12">
        <h2 className="max-w-2xl font-serif text-2xl leading-snug text-[#1E3A5F] sm:text-3xl">{title || t.home.ctaTitle}</h2>
        <Link to={lp("/quote")} className="btn-brass shrink-0 justify-center" data-testid={`${testId}-button`}>{t.common.requestQuote}</Link>
      </div>
    </section>
  );
};
